module.exports = __webpack_public_path__ + "static/img/gsjs_tu4.910025b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gsjs_tu4.png
// module id = fR85
// module chunks = 0